export const selector = '.overlay-fullscreen'

export default (
    el = null
) => {
    if (!el
            || document.body.classList.contains('.wp-admin'))
        return el

    console.groupCollapsed('Overlay Fullscreen')

    const showContent = (e) => {
        const button = e.relatedTarget

        const target = button
            .getAttribute('data-overlay-fullscreen-target')

        const title = el
            .querySelector('[data-overlay-fullscreen-title]')

        const asset = el
            .querySelector('[data-overlay-fullscreen-asset]')

        if (!target
                || !title
                || !asset)
            return

        const targetEl = document
            .querySelector(`[data-overlay-fullscreen-item=${target}]`)

        const targetTitle = targetEl
            .querySelector('[data-overlay-fullscreen-title]')

        const targetAsset = targetEl
            .querySelector('figure, video')

        title.textContent = targetTitle
            ? targetTitle.textContent
            : ''

        if (asset.firstChild)
            asset.removeChild(asset.firstChild)

        asset.appendChild(targetAsset
            .cloneNode(true))
    }

    el.addEventListener('show.bs.modal',
        showContent)

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                el.removeEventListener('show.bs.modal',
                    showContent)
            })

    console.log(el)

    console.groupEnd()

    return el
}
